import { Table } from 'react-bootstrap';
import styled from "styled-components";

export const GridWrapper = styled.div`
    height: 85vh;
    font-family: Roboto;

    .action-menu {
        border-bottom: 1px solid #ccc;
    }

    .action-menu > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
        border-left: 1px solid #ccc;
    }
    
    .action-menu > .ag-cell-wrapper > .ag-cell-value {
        overflow: visible;
        border-bottom: none;
        line-height: 28px;
        border-color: #ccc;
    }

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-cell-focus {
        border-left-color: rgb(204, 204, 204) !important;
        border-top-color: rgb(204, 204, 204) !important;
        border-right-color: white !important;
        border-bottom-color: white !important;
        // user-select: text;
    }

    .center-list-cell {
        border-top: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    .center-list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

export const BulkDeleteTableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
    }
`